import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CoreResponseMessage, CoreResponseStatus } from 'src/app/contracts/responseMessage/coreResponseMessage';
import { FunctionsService } from 'src/app/common/services/functions.service';
import { AuthTokenResponseMessage } from 'src/app/contracts/responseMessage/authTokenResponseMessage';
import { environment } from 'src/environments/environment';
import { ClientConfigService } from 'src/app/common/services/client-config.service';

export enum OrderBy {
    ASC, 
    DESC
}

export class BaseRepository {
    baseApiUrl: string;
    private _userBaseApiUrl: string;

    constructor(public http:HttpClient, public functionsService: FunctionsService, public clientConfig: ClientConfigService, apiControllerName: string) {        
        if (apiControllerName.toLowerCase() === 'user')
            this.baseApiUrl = this.clientConfig.Configuration.baseAppCoreApi + apiControllerName + '/';
        else
            this.baseApiUrl = this.clientConfig.Configuration.baseAppCoreApi + environment.additionalApiNamespace + '/' + apiControllerName + '/';

        this._userBaseApiUrl = this.clientConfig.Configuration.baseAppCoreApi + 'User/';
    }    
    
    async getHeadersAsync(requestorEmail: string): Promise<CoreResponseMessage> {
        let responseMsg: CoreResponseMessage;
        let clientIp = await this.functionsService.getClientIpAsync();

        if (clientIp.ip.length > 0) {
            /*
            application key need to come from configuration file because value will be vary depending on client.
            */
            responseMsg = await this.getAuthTokenAsync(requestorEmail, environment.applicationKey);            

            if (responseMsg.Status === CoreResponseStatus.OK) {
                let authTokenMsg: AuthTokenResponseMessage = responseMsg.Result;
                const headers = new HttpHeaders().set('IpAddress', clientIp.ip)
                                                 .set('Content-Type', 'application/json')
                                                 .set('AuthToken', authTokenMsg.AuthToken);
                responseMsg = {Status: CoreResponseStatus.OK, Message: 'Success to create headers', TotalDataCount: 0, Result: headers};                                          
            }        
        }
        else
            responseMsg = {Status: CoreResponseStatus.Failed, Message: 'Failed to get client IP address!', TotalDataCount: 0, Result: null};

        return responseMsg;
    }

    private async getAuthTokenAsync(email: string, applicationKey: string): Promise<CoreResponseMessage> {    
        const headers = new HttpHeaders().set('EmailAddress', email)
                                         .set('ApplicationKey', applicationKey);            
        let coreResponseMsg: CoreResponseMessage; 
        await this.http.get<CoreResponseMessage>(this._userBaseApiUrl + 'GetAuthToken', { headers }).toPromise().then(resp => {
            coreResponseMsg = resp;
        }).catch(err => {
            coreResponseMsg = err.error;
        });
        
        return coreResponseMsg;
    }

    protected getEncryptedAuthToken(applicationName: string, authToken: string): string {
        let key: string = this.clientConfig.AppEncryptConfig[applicationName];
        let encryptedAuthToken: string = key;        
        
        return encryptedAuthToken;
    }
}